"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _lodash = require("lodash");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '20rem',
      minHeight: '30rem'
    }
  };
};
//const languages = [
//  { label: 'French', value: 'French' },
//  { label: 'Spanish', value: 'Spanish' },
//  { label: 'German', value: 'German' },
//  { label: 'Turkish', value: 'Turkish' },
//  { label: 'Italian', value: 'Italian' },
//  { label: 'Portuguese', value: 'Portuguese' },
//  { label: 'Polish', value: 'Polish' },
//  { label: 'British English', value: 'British English' },
//  { label: 'Japanese', value: 'Japanese' },
//  { label: 'Indonesian', value: 'Indonesian'},
//  { label: 'Chinese', value: 'Chinese'},
//  { label: 'Korean', value: 'Korean' },
//  { label: 'Romanian', value: 'Romanian' },
//];
var QuestionTranslation = /*#__PURE__*/function (_Component) {
  function QuestionTranslation(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, QuestionTranslation);
    _this = _callSuper(this, QuestionTranslation, [props]);
    var question = props.question;
    _this.state = {
      translations: question && question.translations ? question.translations : {},
      hintTranslations: question && question.hintTranslations ? question.hintTranslations : {},
      questionID: question && question.questionID ? question.questionID : '',
      selectedLanguage: '',
      questionDescription: '',
      additionalDescription: '',
      hint: ''
    };
    ['handleSelectChange', 'handleInputChange', 'onClose'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(QuestionTranslation, _Component);
  return (0, _createClass2["default"])(QuestionTranslation, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      var _this$state = this.state,
        translations = _this$state.translations,
        hintTranslations = _this$state.hintTranslations,
        selectedLanguage = _this$state.selectedLanguage;
      this.setState((0, _defineProperty2["default"])({}, name, value), function () {
        if (name === 'hint') {
          hintTranslations[selectedLanguage.value] = value;
        } else {
          if (translations[selectedLanguage.value] === undefined) {
            translations[selectedLanguage.value] = {};
          }
          translations[selectedLanguage.value][name] = value;
        }
      });
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(value) {
      var _this$state2 = this.state,
        translations = _this$state2.translations,
        hintTranslations = _this$state2.hintTranslations,
        selectedLanguage = _this$state2.selectedLanguage;
      this.setState({
        selectedLanguage: value
      });
      if (value.value) {
        if (translations[value.value] === undefined) {
          translations[value.value] = {};
        }
        this.setState({
          hint: hintTranslations[value.value] ? hintTranslations[value.value] : '',
          questionDescription: translations[value.value]['questionDescription'] ? translations[value.value]['questionDescription'] : '',
          additionalDescription: translations[value.value]['additionalDescription'] ? translations[value.value]['additionalDescription'] : ''
        });
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        hint: '',
        questionDescription: '',
        additionalDescription: '',
        selectedLanguage: ''
      });
      this.props.onClose();
    }
  }, {
    key: "onConfirm",
    value: function onConfirm() {
      var question = this.props.question;
      question.translations = this.state.translations;
      question.hintTranslations = this.state.hintTranslations;
      this.props.onConfirm(question);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        onClose = _this$props.onClose,
        onConfirm = _this$props.onConfirm,
        open = _this$props.open,
        languages = _this$props.languages;
      var _this$state3 = this.state,
        selectedLanguage = _this$state3.selectedLanguage,
        questionDescription = _this$state3.questionDescription,
        additionalDescription = _this$state3.additionalDescription,
        hint = _this$state3.hint;
      var options = languages ? [].concat(languages).reduce(function (all, l) {
        if (l.description !== 'English') all.push({
          label: l.description,
          value: l.description
        });
        return all;
      }, []) : [];
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        classes: {
          paper: classes.dialogPaper
        },
        onClose: this.onClose,
        "aria-labelledby": "simple-dialog-title",
        open: open,
        maxWidth: "lg",
        fullWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, "Translations"), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
        onChange: this.handleSelectChange,
        value: selectedLanguage,
        name: "language_select",
        options: options,
        placeholder: "Select a Language"
      }), /*#__PURE__*/_react["default"].createElement("br", null), this.state.selectedLanguage && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, "Question Description"), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: "",
        name: "questionDescription",
        onChange: this.handleInputChange,
        value: questionDescription,
        fullWidth: true,
        multiline: true
      }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "Additional Description"), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: "",
        name: "additionalDescription",
        onChange: this.handleInputChange,
        value: additionalDescription,
        fullWidth: true,
        multiline: true
      }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "Hint"), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: "",
        name: "hint",
        onChange: this.handleInputChange,
        value: hint,
        fullWidth: true,
        multiline: true
      }))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onClose();
        }
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        form: "theForm",
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this2.onConfirm();
        }
      }, "Confirm")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var question = props.question;
      var newState = _objectSpread({}, state);
      if (!(0, _lodash.isEmpty)(question) && question.questionID !== state.questionID && props.questionId !== 'new') {
        Object.keys(question).forEach(function (k) {
          newState[k] = question[k];
        });
      }
      return _objectSpread({}, newState);
    }
  }]);
}(_react.Component);
QuestionTranslation.propTypes = {
  onConfirm: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  question: _propTypes["default"].object
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(QuestionTranslation);